module.exports = __webpack_public_path__ + "static/media/left-img@3x.4ca463b2.png";